import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6 flex flex-col 2xl:flex-row justify-between items-start 2xl:items-center gap-4" }
const _hoisted_2 = { class: "flex flex-col 2xl:flex-row items-start 2xl:items-center gap-3 w-full 2xl:w-auto" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'TireApprovalFilters',
  props: {
    search: {},
    status: {},
    brand: {}
  },
  emits: ["update:search", "update:status", "update:brand", "apply", "reset", "export"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

// Auto-filter when search input changes
function handleSearchInput(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  emit('update:search', value);
  emit('apply');
}

// Auto-filter when status changes
function handleStatusChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:status', value);
  emit('apply');
}

// Auto-filter when brand changes
function handleBrandChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:brand', value);
  emit('apply');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        value: _ctx.search,
        onInput: handleSearchInput,
        type: "search",
        placeholder: "Search tires...",
        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white placeholder-gray-500 focus:ring-2 focus:outline-none shadow-sm w-full 2xl:min-w-[300px] transition-colors duration-200 brand-focus-ring"
      }, null, 40, _hoisted_3),
      _createElementVNode("select", {
        value: _ctx.status,
        onChange: handleStatusChange,
        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring w-full 2xl:w-auto"
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("option", { value: "" }, "All Status", -1),
        _createElementVNode("option", { value: "pending" }, "Pending", -1),
        _createElementVNode("option", { value: "approved" }, "Approved", -1),
        _createElementVNode("option", { value: "rejected" }, "Rejected", -1)
      ]), 40, _hoisted_4),
      _createElementVNode("select", {
        value: _ctx.brand,
        onChange: handleBrandChange,
        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring w-full 2xl:w-auto"
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("option", { value: "" }, "All Brands", -1),
        _createElementVNode("option", { value: "1" }, "Continental", -1),
        _createElementVNode("option", { value: "2" }, "Falken", -1)
      ]), 40, _hoisted_5),
      _createElementVNode("button", {
        type: "button",
        class: "text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center justify-center 2xl:justify-start gap-2 shadow-sm w-full 2xl:w-auto whitespace-nowrap hover:opacity-90",
        style: {"background-color":"var(--brand-primary)"},
        onMouseover: _cache[0] || (_cache[0] = (e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-hover)'),
        onMouseout: _cache[1] || (_cache[1] = (e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-primary)'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reset')))
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"
          })
        ], -1),
        _createElementVNode("span", null, "Clear Filters", -1)
      ]), 32),
      _createElementVNode("button", {
        type: "button",
        class: "bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center justify-center 2xl:justify-start gap-2 shadow-sm w-full 2xl:w-auto whitespace-nowrap",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('export')))
      }, _cache[7] || (_cache[7] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          })
        ], -1),
        _createElementVNode("span", null, "Export Excel", -1)
      ]))
    ])
  ]))
}
}

})